var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgEnforceCard03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1066_11862)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.1055,
    cy: 55.8156,
    r: 44,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1066_11862)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.6055,
    cy: 52.8156,
    rx: 42.5,
    ry: 43,
    fill: "#5FAEEF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.4934 67.1984L59.1865 58.8669L56.1914 49.1188L70.5052 57.4504L73.4934 67.1984Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3947 95.5983L10.0809 87.2667L10.0391 70.6804L24.3459 79.012L24.3947 95.5983Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3459 79.0119L10.0391 70.6804L63.1081 39.9849L77.422 48.3164L24.3459 79.0119Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4237 48.3164L77.4725 64.8958L73.4952 67.1984L70.5071 57.4504L31.2921 80.1284L28.3667 93.2956L24.3964 95.5983L24.3477 79.0119L77.4237 48.3164Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6528 51.0587L58.8175 41.2548L58.8105 39.0638L75.6458 48.8607L75.6528 51.0587Z",
    fill: "#482807"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6458 48.8607L58.8105 39.0638L63.1569 36.5518L79.9922 46.3486L75.6458 48.8607Z",
    fill: "#D88043"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9929 46.3486L79.9998 48.5467L75.6535 51.0587L75.6465 48.8607L79.9929 46.3486Z",
    fill: "#8A5029"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8618 53.8358L54.0265 44.0319L54.0195 41.8339L70.8548 51.6378L70.8618 53.8358Z",
    fill: "#482807"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8548 51.6378L54.0195 41.834L58.3589 39.3289L75.1942 49.1258L70.8548 51.6378Z",
    fill: "#D88043"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1929 49.1258L75.1999 51.3238L70.8605 53.8358L70.8535 51.6378L75.1929 49.1258Z",
    fill: "#8A5029"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0551 56.613L49.2199 46.8091L49.2129 44.6181L66.0482 54.415L66.0551 56.613Z",
    fill: "#482807"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0482 54.415L49.2129 44.6181L53.5523 42.1061L70.3876 51.9099L66.0482 54.415Z",
    fill: "#D88043"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3883 51.91C70.3883 51.9449 70.3883 54.108 70.3883 54.108L66.0488 56.62V54.429L70.3813 51.917L70.3883 51.91Z",
    fill: "#8A5029"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2485 59.3902L44.4132 49.5863L44.4062 47.3953L61.2415 57.1922L61.2485 59.3902Z",
    fill: "#482807"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2415 57.1922L44.4062 47.3953L48.7526 44.8832L65.5879 54.6801L61.2415 57.1922Z",
    fill: "#D88043"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5886 54.6802L65.5955 56.8782L61.2492 59.3902L61.2422 57.1922L65.5886 54.6802Z",
    fill: "#8A5029"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4555 62.1674L39.6202 52.3635L39.6133 50.1655L56.4486 59.9694L56.4555 62.1674Z",
    fill: "#482807"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4486 59.9694L39.6133 50.1655L43.9527 47.6605L60.788 57.4574L56.4486 59.9694Z",
    fill: "#D88043"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7886 57.4574L60.7956 59.6554L56.4562 62.1674L56.4492 59.9694L60.7886 57.4574Z",
    fill: "#8A5029"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6508 64.9446L34.8156 55.1407L34.8086 52.9496L51.6439 62.7465L51.6508 64.9446Z",
    fill: "#482807"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6439 62.7466L34.8086 52.9497L39.155 50.4307L55.9903 60.2345L51.6439 62.7466Z",
    fill: "#D88043"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9909 60.2345C55.9909 60.2694 55.9909 62.4325 55.9909 62.4325L51.6445 64.9445V62.7535L55.984 60.2415L55.9909 60.2345Z",
    fill: "#8A5029"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.852 67.7148L30.0167 57.9179L30.0098 55.7199L46.845 65.5238L46.852 67.7148Z",
    fill: "#482807"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46.845 65.5238L30.0098 55.7199L34.3492 53.2148L51.1845 63.0117L46.845 65.5238Z",
    fill: "#D88043"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1851 63.0118L51.1921 65.2098L46.8527 67.7148L46.8457 65.5238L51.1851 63.0118Z",
    fill: "#8A5029"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0532 70.4989L25.2179 60.695L25.2109 58.497L42.0462 68.3009L42.0532 70.4989Z",
    fill: "#482807"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0462 68.3009L25.2109 58.497L29.5504 55.9919L46.3856 65.7888L42.0462 68.3009Z",
    fill: "#D88043"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3863 65.7888L46.3933 67.9868L42.0538 70.4989L42.0469 68.3008L46.3863 65.7888Z",
    fill: "#8A5029"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2465 73.2761L20.4113 63.4722L20.4043 61.2812L37.2396 71.0781L37.2465 73.2761Z",
    fill: "#482807"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2396 71.0781L20.4043 61.2812L24.7507 58.7622L41.586 68.5661L37.2396 71.0781Z",
    fill: "#D88043"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5866 68.566C41.5866 68.6009 41.5866 70.7641 41.5866 70.7641L37.2402 73.2761V71.085L41.5797 68.573L41.5866 68.566Z",
    fill: "#8A5029"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4477 76.0463L15.6124 66.2494L15.6055 64.0514L32.4407 73.8553L32.4477 76.0463Z",
    fill: "#482807"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4407 73.8552L15.6055 64.0514L19.9449 61.5463L36.7802 71.3432L32.4407 73.8552Z",
    fill: "#D88043"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7808 71.3432L36.7878 73.5412L32.4484 76.0463L32.4414 73.8552L36.7808 71.3432Z",
    fill: "#8A5029"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6489 78.8235L10.8136 69.0266L10.8066 66.8286L27.6419 76.6325L27.6489 78.8235Z",
    fill: "#482807"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6419 76.6325L10.8066 66.8286L15.1461 64.3235L31.9813 74.1204L27.6419 76.6325Z",
    fill: "#D88043"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M31.982 74.1204L31.989 76.3184L27.6495 78.8235L27.6426 76.6324L31.982 74.1204Z",
    fill: "#8A5029"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8422 81.6076L6 71.8038V69.6127L22.8353 79.4096L22.8422 81.6076Z",
    fill: "#9B5D2F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8353 79.4096L6 69.6127L10.3464 67.0938L27.1817 76.8976L22.8353 79.4096Z",
    fill: "#D88043"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1823 76.8976L27.1893 79.0886L22.8429 81.6076L22.8359 79.4096L27.1823 76.8976Z",
    fill: "#8A5029"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0059 33.5024C45.0059 33.5024 47.9801 32.8325 49.3731 33.8164C51.8249 35.5538 53.0996 43.1318 53.0996 43.1318L57.7803 54.7708L54.0957 54.0312L49.9582 50.3538L48.1681 39.8173L45.0059 33.5024Z",
    fill: "#8196B3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0917 39.8941L52.3834 49.5933L55.2183 53.3683L52.3834 54.8406L47.9395 46.6277L50.0917 39.8941Z",
    fill: "#4C6584"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6367 86.4851C42.6367 86.4851 42.783 90.2741 43.2009 91.886C43.6119 93.5048 45.2278 94.8585 47.1224 94.5934C49.017 94.3352 48.418 93.128 48.4528 92.3744C48.4876 91.6208 46.6139 86.1851 46.6139 86.1851L46.5304 85.8571C46.4886 85.892 46.4607 85.9339 46.4398 85.9897C46.3284 86.2479 46.6627 86.5828 46.7532 86.827C47.1224 87.8179 47.3662 88.8715 47.6657 89.8903C47.8886 90.6509 48.1045 91.4185 48.1394 92.2139C48.1463 92.4023 48.1394 92.6047 48.0767 92.7791C48.014 92.9536 47.8677 93.121 47.6866 93.1629C47.5403 93.1978 47.3941 93.1629 47.2408 93.1629C46.8856 93.1629 46.5582 93.3374 46.2169 93.4211C45.2766 93.6444 44.2736 93.0931 43.7303 92.2907C43.187 91.4882 43.0198 90.4904 42.978 89.5205C42.9362 88.5506 43.0059 87.5737 42.8666 86.6107C42.8387 86.4084 42.7969 86.1921 42.7064 86.0037L42.6576 86.4921L42.6367 86.4851Z",
    fill: "#141C26"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1914 56.3269C37.1914 56.3269 42.5408 62.4395 45.2921 62.1394C45.4036 62.1255 45.5359 62.1185 45.6752 62.1115C48.8654 62.0138 58.1293 63.9955 61.201 64.1421C59.801 67.1704 57.2099 77.3441 57.377 78.2512C57.4119 78.4396 57.5163 78.6071 57.6765 78.7606C58.8885 79.8771 62.9145 80.0934 63.1026 79.277C64.9553 71.6781 69.1554 64.3653 68.1594 61.4347C64.5096 54.3242 49.3529 53.1171 49.3529 53.1171L40.9875 55.3221L37.1984 56.3199L37.1914 56.3269Z",
    fill: "#A6423F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8741 64.0513L41.1956 72.4038C40.4225 75.4671 41.1747 79.7724 41.2444 85.0826C41.2235 85.4035 41.53 85.7315 41.9967 86.0176C43.4663 86.9247 46.5938 87.3922 46.747 85.6826L47.6456 72.3061C47.6595 71.4688 47.5968 70.5407 47.4645 69.5778C47.1301 67.0658 46.3918 64.2886 45.6744 62.1045C44.9082 59.7739 44.1768 58.1272 43.9957 58.2248L45.8137 56.4874L49.3451 53.1171L35.3935 54.1149C35.3308 54.4359 35.2751 54.7429 35.2194 55.0569C34.495 59.0343 34.3348 62.1813 35.8741 64.0513Z",
    fill: "#A6423F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8741 64.0514L41.1956 72.4038C40.4225 75.4671 41.1747 79.7724 41.2444 85.0826C41.2235 85.4036 41.53 85.7315 41.9966 86.0176C41.8504 80.1911 41.6205 74.1413 42.6375 71.6502C40.5061 69.6057 34.5159 61.5324 36.7378 58.0504C37.9846 59.6832 39.5936 61.4556 40.9518 61.8324C43.5987 62.579 45.5768 66.9821 45.5768 66.9821L47.4714 69.5778C47.1371 67.0658 46.3988 64.2886 45.6813 62.1045C48.8715 62.0069 58.1354 63.9886 61.2071 64.1351C59.8071 67.1635 57.216 77.3372 57.3831 78.2443C57.418 78.4327 57.5224 78.6002 57.6826 78.7537C57.7035 78.7676 57.8777 78.9072 57.8777 78.9072C59.5424 72.7178 61.3743 67.1635 63.5057 62.7326C57.8568 61.4975 56.8538 60.5764 52.8765 59.0413L53.5383 53.7102L49.7839 53.152L40.9867 55.3151L39.9001 55.05H35.2194C34.495 59.0273 34.3348 62.1743 35.8741 64.0444V64.0514Z",
    fill: "#A6423F"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6415 55.1895C50.5718 55.5454 50.4604 55.8943 50.3141 56.2223C49.9937 56.9549 49.4783 57.5969 48.8096 58.0644C46.1349 59.9554 42.3945 60.702 39.3367 60.3252C38.5496 60.1299 37.7625 59.9275 37.0103 59.6623C36.7804 59.5786 36.5575 59.4739 36.3555 59.3483C35.046 58.5878 34.2729 57.0875 34.3704 55.5384C34.3704 55.5035 34.3704 55.4826 34.3704 55.4477C34.4052 55.1267 34.4191 54.7918 34.44 54.4569C34.4609 54.1219 34.4679 53.78 34.4749 53.4311L34.0569 47.9186L33.3047 37.9822C35.6102 35.4771 38.271 33.314 41.2731 31.4509L47.2911 31.737C49.6176 33.3908 50.1469 35.4632 50.5022 38.2543C50.5022 38.2543 50.0633 49.37 50.4534 52.0774C50.5161 52.5101 50.5857 52.9776 50.6693 53.459C50.7599 54.0382 50.7529 54.6174 50.6415 55.1826V55.1895Z",
    fill: "#8196B3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2088 42.3643C38.8706 49.6631 43.3423 52.0146 50.3564 50.7935C50.3843 51.3168 50.4122 51.7634 50.4609 52.0844C50.5236 52.517 50.5933 52.9845 50.6768 53.466C50.7674 54.0452 50.7604 54.6243 50.649 55.1895C50.5793 55.5454 50.4679 55.8943 50.3216 56.2223C50.0012 56.9549 49.4858 57.5969 48.8171 58.0644C46.1424 59.9554 42.402 60.702 39.3442 60.3252C38.5571 60.1298 37.77 59.9275 37.0178 59.6623C36.7879 59.5786 36.565 59.4739 36.363 59.3483C35.0535 58.5877 34.2804 57.0875 34.3779 55.5384C34.3779 55.5035 34.3779 55.4826 34.3779 55.4477C34.4127 55.1267 34.4267 54.7918 34.4475 54.4569C34.4684 54.1219 34.4754 53.78 34.4824 53.4311L34.0645 47.9186L38.2088 42.3643Z",
    fill: "#4C6584"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M41.969 30.7671L39.2316 32.8046C37.7619 36.8518 41.0496 38.6381 43.1531 40.9896L44.5532 37.4588L47.7015 38.1845L46.7264 32.3231L41.969 30.7671Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6355 30.502L40.3678 32.7349C39.3508 35.4423 42.5688 37.6961 44.547 37.3681L46.546 33.7606L41.6355 30.502Z",
    fill: "#FFB294"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7462 32.6581C41.0636 35.6027 41.788 36.5377 43.808 37.8217C44.4209 38.2473 46.0996 37.9542 46.5453 37.5774L47.9106 35.2468C48.5723 34.563 49.0111 33.7536 49.3036 32.8534L46.7961 27.6829H42.9025L41.0566 30.2298L41.7392 32.665L41.7462 32.6581Z",
    fill: "#FFB294"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7705 32.2115L42.3169 32.5395C42.7975 32.0998 43.4801 32.058 43.9885 32.4139C44.8035 32.986 46.1478 33.6978 47.708 33.5861C49.5748 33.4535 50.4524 32.0231 50.3549 30.6415C50.2434 29.1622 47.7498 25.8128 44.8662 26.0082C41.4601 26.2385 39.8302 28.7854 40.471 32.5604L40.7775 32.2185L40.7705 32.2115Z",
    fill: "#E6E6E6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3839 30.5228C41.1331 30.467 40.8476 30.5508 40.7083 30.7671C40.6038 30.9206 40.5898 31.116 40.5898 31.2974C40.5898 31.6881 40.6874 32.0789 40.8615 32.4348C40.9311 32.5813 41.0217 32.7278 41.1471 32.8395C41.2724 32.9511 41.4396 33.0139 41.5998 32.993C42.1849 32.9093 42.0804 32.1626 42.1292 31.7509C42.1919 31.2625 41.8924 30.6554 41.3839 30.5368V30.5228Z",
    fill: "#FFB294"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3111 37.9822C31.6673 41.2408 31.4862 46.6486 31.2773 50.012C31.1031 52.7612 31.8972 53.3125 33.8544 54.2754C36.6058 55.6361 41.189 56.7665 45.1871 57.1782C46.2667 56.9061 46.2737 54.7709 45.4936 53.787L37.1908 50.3609L37.9222 44.9042C39.2247 39.5312 35.9649 35.4004 33.3181 37.9822H33.3111Z",
    fill: "#8196B3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1822 54.708L42.5762 54.2964L45.5991 45.5461C48.9704 45.3996 52.4322 45.2321 54.1456 45.5671C55.0372 44.3529 56.082 43.2155 57.3149 42.1549L58.1159 42.455L54.1874 50.5353L43.1822 54.708Z",
    fill: "#FFF1DB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7289 50.7586L51.3438 54.3312L54.8613 45.7276L58.2395 42.1549L54.7289 50.7586Z",
    fill: "#C7363B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3909 54.9871L42.8613 54.9592L45.9888 46.0276L53.9154 46.0625L50.3909 54.9871Z",
    fill: "#C7363B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9151 46.0625L50.3906 54.9942C50.927 54.9104 51.0663 54.9942 51.3518 54.3313L54.8694 45.7346C54.5907 46.0137 54.2843 46.1742 53.9151 46.0695V46.0625Z",
    fill: "#172935"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9982 56.3409L50.7674 54.9802L51.3455 53.1381C51.4291 52.9078 51.2202 52.7752 51.0391 52.8241L51.1993 52.1681C51.3664 51.8611 50.8789 51.5611 50.7117 51.8541C50.8858 51.4773 50.3634 51.2331 50.1545 51.568C50.1336 51.3099 49.7017 51.282 49.4649 51.596L48.845 52.6496L47.9743 53.787L46.4768 54.9593H45.2509H44.624C44.3871 55.6431 44.4359 56.3548 45.0489 56.8503C46.623 57.4364 47.5425 57.2131 49.0052 56.3409H48.9982Z",
    fill: "#FFB294"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5201 53.2985C55.0573 53.0752 53.8175 54.0033 53.8175 54.0033L52.9399 54.8616L52.3966 55.657C52.313 56.0269 52.7797 55.9641 53.107 55.7338L54.1727 54.7709L54.6951 54.8197L54.6673 55.5524L54.528 56.5293C54.4235 56.8991 54.9389 56.9689 55.0573 56.6339L55.719 54.8616L56.1439 55.0221L55.9768 55.7826L55.8792 56.934C55.8375 57.3317 56.2763 57.4573 56.3668 57.2061L56.736 56.0548L56.9658 55.0221L57.14 55.1756V56.1804L57.0494 57.0666C57.0216 57.5899 57.537 57.6457 57.6206 57.3247L57.7808 56.306L57.941 55.5803L58.3171 55.9431C58.3171 55.9431 58.533 56.5014 58.5539 56.5642C58.6236 56.8084 58.7977 57.2689 58.7977 57.2689C58.9579 57.4992 59.0903 57.4992 59.1948 57.2899L59.146 56.3967L58.8256 55.6082C58.6515 55.0151 58.3032 54.4499 57.7529 53.9335C57.7529 53.9335 57.0564 53.3823 56.5201 53.2985Z",
    fill: "#FFB294"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1066_11862",
    x: -1.89453,
    y: 1.81561,
    width: 109,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1066_11862"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1066_11862",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1066_11862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 103,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEnforceCard03);
export default __webpack_public_path__ + "static/media/img-enforce-card-03.d85296dc4a385e040dd78261cd5daf03.svg";
export { ForwardRef as ReactComponent };